import React, { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import { calculateNetSalary } from './utils/netSalaryCalculator'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const formatBRL = (value) =>
  value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

const NetSalaryCalculator = () => {
  useDocumentMeta({
    title: 'Calculadora de Salário Líquido CLT | jarder.dev',
    description:
      'Calcule seu salário líquido a partir do bruto, com desconto de ' +
      'INSS e IRRF pelas tabelas atuais. Grátis, apenas uma estimativa.',
  })

  const [gross, setGross] = useState('3000')
  const [dependents, setDependents] = useState('0')

  const result = useMemo(() => {
    const grossNum = parseFloat(gross.replace(',', '.'))
    if (!grossNum || grossNum <= 0) return null
    const dependentsNum = Math.max(0, Number.parseInt(dependents, 10) || 0)
    return calculateNetSalary({ gross: grossNum, dependents: dependentsNum })
  }, [gross, dependents])

  const handleChange = () => trackEvent('tool_generate', { tool: 'net_salary' })

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Calculadora de Salário Líquido CLT</h1>
      <p className="tool-disclaimer">
        Estimativa com base nas tabelas de INSS e IRRF vigentes. Não
        considera outros descontos (vale-transporte, plano de saúde,
        pensão etc.). Use como referência, não como valor exato do seu
        holerite.
      </p>

      <div className="tool-row">
        <div className="tool-field">
          <label htmlFor="gross">Salário bruto (R$)</label>
          <input
            id="gross"
            type="text"
            inputMode="decimal"
            value={gross}
            onChange={(e) => setGross(e.target.value)}
            onBlur={handleChange}
          />
        </div>
        <div className="tool-field">
          <label htmlFor="dependents">Dependentes</label>
          <input
            id="dependents"
            type="number"
            min="0"
            value={dependents}
            onChange={(e) => setDependents(e.target.value)}
            onBlur={handleChange}
          />
        </div>
      </div>

      {result && (
        <div className="tool-result-card">
          <span className="tool-result-label">Salário líquido estimado</span>
          <span className="tool-result-value">{formatBRL(result.net)}</span>
          <ul className="tool-list">
            <li>
              <strong>Salário bruto:</strong> {formatBRL(result.gross)}
            </li>
            <li>
              <strong>Desconto INSS:</strong> -{formatBRL(result.inss)}
            </li>
            <li>
              <strong>Desconto IRRF:</strong> -{formatBRL(result.irrf)}
            </li>
          </ul>
        </div>
      )}

      <div className="tool-info-section">
        <h2>Como é calculado</h2>
        <p>
          O INSS é descontado por faixas progressivas sobre o salário
          bruto. Depois, a base de cálculo do IRRF é o salário menos o
          INSS e a dedução por dependente (R$ 189,59 cada), aplicada
          também por faixas progressivas com parcela a deduzir.
        </p>
      </div>
    </div>
  )
}

export default NetSalaryCalculator
